"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.delete.confirm.title': '删除入职',
    'onboarding.delete.confirm.message': '确定要删除此入职会话吗？',
};
